import { render, staticRenderFns } from "./ViewSupplementalDocumentation.vue?vue&type=template&id=10c4f2cd"
import script from "./ViewSupplementalDocumentation.vue?vue&type=script&lang=js"
export * from "./ViewSupplementalDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VList,VListItemGroup})
